import React, { ReactNode } from 'react';
import { useVisibility } from './useVisibility';

interface VisibilityWrapperProps {
  threshold?: number;
  children: (isVisible: boolean) => ReactNode;
}

export const VisibilityWrapper: React.FC<VisibilityWrapperProps> = ({
  threshold,
  children,
}) => {
  const [isVisible, ref] = useVisibility(threshold);

  return <div ref={ref}>{children(isVisible)}</div>;
};
